export class Dropdown
{
    constructor(data)
    {
        this.data = data
        this.multipleOption = false;
        this.containerLabel = false;
        this.outerLabel = false;
        this.classes = [
            'form-select'
        ];
        this.isRequired = false;
        this.modalContainer = false;
        this.customAllSelection = false;
        this.useSelect2 = true;
        this.allOptionText = '- ALL -';
    }

    label(label) {
        this.labelOption = label;
        return this;
    }

    setContainerLabel(labelText) {
        this.containerLabel = labelText;
        return this;
    }

    all(all) {
        this.allOption = all;
        return this;
    }

    customAll(all) {
        this.customAllSelection = all;
        return this;
    }

    addClass(className) {
        let classNames = className.split(' ');
        this.classes.push(...classNames);
        return this;
    }

    required(required) {
        this.isRequired = required;
        return this;
    }

    multiple(multiple) {
        this.multipleOption = multiple;
        return this;
    }

    isModalContainer(modalContainer) {
        this.modalContainer = modalContainer;
        return this
    }

    setUseSelect2(useSelect2) {
        this.useSelect2 = useSelect2;
        return this;
    }

    setAllOptionText(allOptionText) {
        this.allOptionText = allOptionText;
        return this;
    }

    draw(
        container,
        keyName,
        valueName,
        ddName,
        dataNames,
        nameAsArray = false
    ) {
        this.container = container;
        let name = '';
        let id = '';
        let multiple = '';
        let required = '';

        if (ddName) {
            const nameSuffix = nameAsArray ? '[]' : '';
            name = `name = "${ddName}${nameSuffix}"`;
            id = `id = "${ddName}"`;
        }

        if (this.multipleOption) {
            multiple = ' multiple ';
        }

        if (this.isRequired) {
            required = ' required ';
        }

        let select = $('<select class = "' + this.classes.join(' ') + '" ' + name + id + multiple + required + '>');

        if (this.labelOption && !this.multipleOption) {
            select.append('<option selected disabled value="">' + this.labelOption + '</option>')
            select.append('<option value="" disabled>')
        }

        if (this.containerLabel) {
            this.container.prepend(`<label for="${ddName}">${this.containerLabel}</label>`);
        }

        if (this.allOption) {
            select.append('<option value="">' + this.allOptionText + '</option>')
        }

        this.data.forEach((element) => {
            let option = $('<option>').val(element[keyName]).text(element[valueName]);

            if (dataNames) {
                dataNames.forEach((dn) => {
                    option.data(dn, element[dn]);
                });
            }

            if (element[keyName] == '') {
                let skip = keyName == 'rdt'; // TODO: Figure out a cleaner solution

                if (!skip) {
                    option.prop('disabled', true).text('• ' + element[valueName]);
                }
            }

            select.append(option);
        });

        this.container.append(select);

        if (this.multipleOption && this.useSelect2) {
            this.refreshMultiSelect();
        }
    }

    refreshMultiSelect() {
        const customAllSelection = this.customAllSelection;

        this.container.find('select').first().select2({
            linkInfo: {
                checkAll: {text: 'All', title: 'Check All foos'},
                uncheckAll: {text: 'None', title: 'Un-check All foos'},
                noneSelectedText: 'None'
            },
            dropdownParent: this.modalContainer ? this.container.parents('.modal .modal-content') : $(document.body),
            classes: 'form-select input-group-text w-100',
            placeholder: this.labelOption,
            selectedText: (numChecked, numTotal, checkedItems) => {
                let text = this.labelOption + ': ';

                if (numChecked < 2) {
                    text += checkedItems[0].nextElementSibling.innerText;
                } else {
                    text += numChecked + ' of ' + numTotal + ' selected';
                }

                return text;
            }
        }).on('select2:select', function(e) {
            if (customAllSelection) {
                const selectedValue = e.params.data.text;

                if (selectedValue === 'All') {
                    $(this).val(e.params.data.id.split(',')).trigger('change');
                }
            }
        });
    }
}
